<template>
<div class="Settle">
  <div class="right">
    <div class="main">
      <div class="steps">
        我的入驻信息
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm from">
        <div class="status" v-if="StatusReviewer == '0'">
          <el-row type="flex" align="middle">
            <el-col :span="4">
              <img src="../../../assets/regitimg/icon_shhetguo_01.png" style="width:62px;height:62px">
            </el-col>
            <el-col :span="18">
              <p>待审核</p>
              <p>待审核中: 平台工作人员将在1~3个工作审批，请及时查看结果~</p>
              <p>注册手机号: {{phoneRedit}}</p>
            </el-col>
          </el-row>
          <div class="wrp">

          </div>

        </div>
        <div class="status" v-else>
          <el-row type="flex" align="middle">
            <el-col :span="4">
              <img src="../../../assets/regitimg/icon_shhetguo_01.png" style="width:62px;height:62px">
            </el-col>
            <el-col :span="18">
              <p>审核拒绝</p>
              <p>未通过原因: {{remarks}}</p>
              <p>注册手机号: {{phoneRedit}}</p>
            </el-col>
          </el-row>
          <div class="wrp">

          </div>

        </div>

        <div class="opt-index" v-if="StatusParams == 1">
          <h4>营业证件信息(必填)</h4>
          <el-form-item label="公司名称 :" prop="companyname">
            <el-input style="width: 100%" maxlength="60" show-word-limit v-model="ruleForm.companyname" placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码 :" prop="unified_credit_code">
            <el-input style="width: 100%" maxlength="18" show-word-limit v-model="ruleForm.unified_credit_code" placeholder="请输入统一信用代码"></el-input>
          </el-form-item>
          <el-form-item label="上传营业执照 :" prop="businessNotes">
            <el-upload action="123" :class="{ hide: hidezhuFile }" :file-list="ruleForm.businessNotes" list-type="picture-card" :on-change="handleBusiness" :auto-upload="false" :limit="1" accept=".gif,.jpg,.jpeg,.png,.GIF,.JPG,.PNG" :on-remove="RemoveBusiness">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="主体类型 :">
            <span>企业</span>
          </el-form-item>
          <el-form-item label="营业期限 :" prop="businessRadio" message="请选择" class="time_radio" style="align-items: center">
            <el-radio v-model="ruleForm.businessRadio" label="1">
              <el-date-picker :disabled="ruleForm.businessRadio == '2'" v-model="ruleForm.business_time" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-radio>
            <el-radio v-model="ruleForm.businessRadio" label="2">长期有效</el-radio>
          </el-form-item>
          <el-form-item label="经营地址" prop="businessAddress">
            <el-cascader v-model="ruleForm.businessAddress" placeholder="请选择经营地址" :options="options"></el-cascader>
          </el-form-item>
        </div>
        <div class="opt-index">
          <h4>{{ StatusParams == 1 ? "法定代表人信息(必填) :" : "个人信息(必填) :" }}</h4>
          <el-form-item label="身份证归属地 :" label-width="180px" prop="identity_address">
            <el-input style="width: 100%" v-model="ruleForm.identity_address" disabled placeholder="请选择身份证归属地"></el-input>
          </el-form-item>
          <el-form-item label="身份证件照 :" label-width="180px" prop="cards">
            <div class="face-index">
              <div class="img-index">
                <el-upload action="123" :file-list="ruleForm.cardFace" :class="{ hide: hideUpload }" list-type="picture-card" :on-change="handleCardFace" :auto-upload="false" :on-preview="handlePictureCardPreview" :limit="1" accept=".gif,.jpg,.jpeg,.png,.GIF,.JPG,.PNG" :on-remove="CardFaceRemove">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div class="img-text">上传身份证照片（正面）</div>
              </div>
              <div class="img-index">
                <el-upload action="123" :file-list="ruleForm.cardBack" :class="{ hide: hideUpload1 }" list-type="picture-card" :on-change="handleCardBack" :auto-upload="false" :on-preview="handlePictureCardPreview" :limit="1" accept=".gif,.jpg,.jpeg,.png,.GIF,.JPG,.PNG" :on-remove="CardBackRemove">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div class="img-text">上传身份证照片（反面）</div>
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="`${StatusParams == 1 ? '法定代表人姓名 :' : '姓名 :'}`" label-width="180px" prop="personName">
            <el-input style="width: 100%" maxlength="60" show-word-limit v-model="ruleForm.personName" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item :label="`${StatusParams == 1 ? '法定代表人身份证号码 :' : '身份证号码 :'}`" label-width="180px" prop="identity_number">
            <el-input style="width: 100%" maxlength="18" show-word-limit v-model="ruleForm.identity_number" placeholder="请输入身份证号码"></el-input>
          </el-form-item>

          <el-form-item :label="`${StatusParams == 1 ? '法定代表人身份证有效期 :' : '身份证有效期 :'}`" class="time_radio" prop="identity_radio" message="请选择" label-width="190px" style="align-items: center">
            <el-radio v-model="ruleForm.identity_radio" label="1">
              <el-date-picker :disabled="ruleForm.identity_radio == '2'" v-model="ruleForm.identity_time" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-radio>
            <el-radio v-model="ruleForm.identity_radio" label="2">长期有效</el-radio>
          </el-form-item>
        </div>

        <div class="opt-index">
          <h4>运营人信息(必填)</h4>
          <el-form-item label="运营联系人:" prop="opt_user">
            <el-input style="width: 100%" v-model="ruleForm.opt_user" placeholder="请输入运营联系人姓名"></el-input>
          </el-form-item>
          <el-form-item label="运营人电话:" prop="phone">
            <el-input style="width: 100%" v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="联系邮箱:" prop="email">
            <el-input style="width: 100%" v-model="ruleForm.email" placeholder="请输入邮箱地址"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button style="background: #e72f0d; width: 300px; color: #fff; margin-top: 20px; margin-left: 40%; transform: translateX(-40%)" v-if="StatusReviewer == 2" :loading="disabled" @click="submitForm">注册</el-button>
        </el-form-item>
      </el-form>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </div>
  </div>
</div>
</template>

<script>
import RQ from '@/assets/js/common1'
import config from "@/assets/config.json";
import {
  mapActions,
  mapGetters
} from "vuex";
import addressData from "@/assets/area_data.json";
export default {
  data() {
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else {
        if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('手机号码有误，请重填'));
        } else {
          callback();
        }
      }
    };

    let pattern18 = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/;
    /*  /^[1-9]\d{5}(18|19|([2-9]\d[0-9]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    let pattern15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/; */
    var validateSfz = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('身份证不能为空!!'))
      } else {
        if (pattern18.test(value) == false) {
          callback(new Error('身份证格式有误'))
        } else {
          callback()
        }
      }

      /*  if (!value) {
         return callback(new Error('身份证不能为空!!'))
       } else if (value.length >= 18) {
         if (pattern18.test(value) == false) {
           callback(new Error('身份证格式有误'))
         } else {
           callback()
         }
       } else if (value.length >= 15) {
         if (pattern15.test(value) == false) {
           callback(new Error('身份证格式有误'))
         } else {
           callback()
         }
       } */
    };
    var chineseChart = (rule, value, callback) => {
      console.log(value, 5)
      if (!value) {
        callback(new Error('请输入公司名称'));
      } else {
        if (!(/^[\u4e00-\u9fa5]+$/.test(value))) {
          callback(new Error('请输入中文公司名称'));
        } else {
          callback();
        }
      }
    }
    let qyReg = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/
    var cqyReg = (rule, value, callback) => {
      console.log(value, 5)
      if (!value) {
        callback(new Error('请输入统一社会信用代码'));
      } else {
        if (!(qyReg.test(value))) {
          callback(new Error('请输入正确统一社会信用代码'));
        } else {
          callback();
        }

      }
    }

    return {
      type: '',
      phoneRedit: '',
      StatusParams: '',
      StatusReviewer: '',

      remarks: '',
      ruleForm: {
        companyname: "", //公司名称
        unified_credit_code: "", //统一社会信用代码
        businessNotes: [], //上传营业执照
        businessRadio: "1",
        business_time: [], // 营业时间
        businessAddress: [], //经营地址
        businessNotesUrl: "", //营业执照路径

        personName: "", //身份证姓名
        identity_number: "", //身份证号码
        identity_address: "中国大陆", //身份证归属地
        cards: [],
        cardFace: [], //身份证正面
        cardBack: [], //身份证反面
        cardFaceUrl: "", //身份证url
        cardBackUrl: "",
        identity_radio: "1",
        identity_time: [], //身份证时间

        //运营人信息
        opt_user: "",
        phone: "",
        email: "",
      },
      options: addressData,
      befortime: [],
      lasttime: [],
      disabled: false,
      hideUpload: false,
      hideUpload1: false,
      hidezhuFile: false,
      dialogVisible: false,
      dialogImageUrl: "",
      dialogImageUrlBack: "",
      rules: {
         companyname: [{
          required: true,
          trigger: 'blur',
          validator: chineseChart
        }, ],
        unified_credit_code: [{
          required: true,
          validator: cqyReg,
          trigger: 'blur'
        }],
        businessNotes: [{
          required: true,
          message: "请上传营业执照"
        }],
        businessRadio: [{
          required: true,
          message: "请选择营业执照有效期"
        }],

        businessAddress: [{
          required: true,
          message: "请选择经营地址",
          trigger: "blur"
        }],
        personName: [{
          required: true,
          message: "请输入姓名",
          trigger: "blur"
        }],
        identity_number: [{
          required: true,
          validator: validateSfz,
          trigger: "blur"
        }],
        cards: [{
          required: true,
          message: "请上传身份证"
        }],
        identity_address: [{
          required: true,
          message: "请选择身份证归属地",
          trigger: "blur"
        }],
        identity_radio: [{
          required: true,
          message: "请选择身份证有效期"
        }],
        opt_user: [{
          required: true,
          message: "请输入运营联系人姓名"
        }],
        phone: [{
          required: true,
          message: "请输入手机号"
        }],
        email: [{
            required: true,
            message: "请输入邮箱地址",
            trigger: "blur"
          },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          },
        ],
      },
      access_token: "",
    };
  },
  computed: {
    ...mapGetters({
      userRegist: "product/getUserRegist",
      Regist: "getRegist",
    }),
  },
  created() {
    this.phoneRedit = this.$route.query.phone
    this.getDetail();
  },
  mounted() {

  },
  methods: {
    ...mapActions({
      uploadBase64: "product/uploadBase64",
      getImgInfo: "product/getImgInfo",
      buyerSettle: "product/buyerSettle",
      checkPass: "detect/checkPass",
    }),
    getDetail() {
      let params = {
        cellphone: this.$route.query.phone,
      };
      this.checkPass(params).then((res) => {
        if (res.data.code == 1) {
          this.info = res.data.data.info
          this.StatusReviewer = res.data.data.info.reviewer_status
          this.StatusParams = res.data.data.info.type
          this.remarks = res.data.data.info.remarks

          if (this.StatusParams == 3) {
            this.hideUpload1 = true
            this.hideUpload = true
            this.ruleForm.cards.push(1)
          } else {
            this.ruleForm.cards.push(1)
            this.hidezhuFile = true
            this.hideUpload1 = true
            this.hideUpload = true
          }
          this.ruleForm.companyname = res.data.data.info.company_name;
          this.ruleForm.unified_credit_code = res.data.data.info.unified_credit_code;
          this.ruleForm.businessNotes.push({
            url: res.data.data.info.business_licenses_imgs,
          });
          this.ruleForm.businessNotesUrl = res.data.data.info.business_licenses_imgs
          this.type = res.data.data.info.type
          if (res.data.data.info.business_licenses_time_start != null && res.data.data.info.business_licenses_time_end != '') {
            this.ruleForm.businessRadio = '1';
            this.ruleForm.business_time = [RQ.getRQ(res.data.data.info.business_licenses_time_start), RQ.getRQ(res.data.data.info.business_licenses_time_end)];
          } else {
            this.ruleForm.businessRadio = '2';
          }
          this.ruleForm.cardFaceUrl = res.data.data.info.identity_front_photo,
            this.ruleForm.cardBackUrl = res.data.data.info.identity_back_photo,
            this.ruleForm.cardFace.push({
              url: res.data.data.info.identity_front_photo,
            })
          this.ruleForm.cardBack.push({
            url: res.data.data.info.identity_back_photo,
          })

          this.$nextTick(() => {
            this.ruleForm.businessAddress = [res.data.data.info.address_provinces.toString(), res.data.data.info.address_citys.toString(), res.data.data.info.address_zones.toString(), ]
          })
          /* this.ruleForm.businessAddress = [res.data.data.info.address_provinces, res.data.data.info.address_citys, res.data.data.info.address_zones] */
          this.ruleForm.personName = res.data.data.info.real_name
          this.ruleForm.identity_number = res.data.data.info.identity_number
          this.ruleForm.opt_user = res.data.data.info.operator_name
          this.ruleForm.phone = res.data.data.info.operator_cellphone
          this.ruleForm.email = res.data.data.info.email
          //身份证时间
          if (res.data.data.info.identity_time_start != null && res.data.data.info.identity_time_end != '') {
            this.ruleForm.identity_radio = '1';
            this.ruleForm.identity_time = [RQ.getRQ(res.data.data.info.identity_time_start), RQ.getRQ(res.data.data.info.identity_time_end)];
          } else {
            this.ruleForm.identity_radio = '2';
          }
        }
        console.log(this.ruleForm.cardFaceUrl, '88888888888888');
      });
    },
    // goAdmin() {
    //     // window.open(config.admin);
    //     // window.open('http://114.113.149.156:8108/business')
    // },
    getWeiXinInfoFN(img_url) {
      let opt = {
        img: img_url,
      };
      this.getImgInfo(opt).then((res) => {
        if (res.code == 1) {
          if (res.data.name && res.data.id) {
            this.ruleForm.personName = res.data.name;
            this.ruleForm.identity_number = res.data.id;
          }

          if (res.data.valid_date) {
            if (res.data.valid_date.split("-")[1] == "长期") {
              this.ruleForm.identity_radio = "2";
            } else {
              this.ruleForm.identity_time = res.data.valid_date.split("-");
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.disabled = true;
          let data = {
            company_name: this.ruleForm.companyname,
            unified_credit_code: this.ruleForm.unified_credit_code,
            business_licenses_imgs_urls: this.ruleForm.businessNotesUrl,
            address_provinces: this.ruleForm.businessAddress[0],
            address_citys: this.ruleForm.businessAddress[1],
            address_zones: this.ruleForm.businessAddress[2],
            real_name: this.ruleForm.personName,
            identity_number: this.ruleForm.identity_number,
            identity_address: this.ruleForm.identity_address,
            operator_name: this.ruleForm.opt_user,
            operator_cellphone: this.ruleForm.phone,
            email: this.ruleForm.email,
            cellphones: this.phoneRedit,
            reset_type: 1,
            type: this.type,
            identity_front_photo: this.ruleForm.cardFaceUrl,
            identity_back_photo: this.ruleForm.cardBackUrl
          };
          if (this.ruleForm.businessRadio == 1) {
            data.business_licenses_type = 1;
            data.business_licenses_time_start = this.ruleForm.business_time[0];
            data.business_licenses_time_end = this.ruleForm.business_time[1];
          } else {
            data.business_licenses_type = 2;
          }
          if (this.ruleForm.identity_radio == 1) {
            data.id_card_type = 1;
            data.identity_time_start = this.ruleForm.identity_time[0];
            data.identity_time_end = this.ruleForm.identity_time[1];
          } else {
            data.id_card_type = 2;
          }
          this.buyerSettle(data).then((res) => {
            this.disabled = false;
            if (res.code == 1) {
              this.$message({
                message: "已为您提交申请！",
                type: "success",
              });
              this.$router.push("/login");
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    //  上传身份证反面
    handleCardBack(file, fileList) {
      let type = this.isImage(file.name);
      if (type == true) {
        this.hideUpload1 = fileList.length >= 1;
        this.getBase64(file.raw).then((res) => {
          this.uploadBase64({
            codes_base64: res.split(";base64,")[1],
            extensions: file.name.split(".")[1]
          }).then((res) => {
            if (res.code == 1) {
              this.ruleForm.cardBackUrl = res.data.urls;
              this.ruleForm.cards.push(1);
              this.getWeiXinInfoFN(res.data.urls);
            } else {
              this.$message.error(res.msg);
            }
          });
        });
        this.ruleForm.cardBack = fileList.slice(-1);
      } else {
        this.ruleForm.cardBack = [];
        this.$message.error("请选择图片");
      }
    },
    CardBackRemove(file, fileList) {
      this.hideUpload1 = fileList.length >= 1;
      this.ruleForm.cardBack.splice(0, this.ruleForm.cardBack.length);
      this.ruleForm.cardBackUrl = "";
    },
    //上传身份证正面
    handleCardFace(file, fileList) {
      let type = this.isImage(file.name);
      if (type == true) {
        this.hideUpload = fileList.length >= 1;
        // var formdata=new FormData();
        // formdata.append("formdata",file);
        this.getBase64(file.raw).then((res) => {
          this.uploadBase64({
            codes_base64: res.split(";base64,")[1],
            extensions: file.name.split(".")[1]
          }).then((res) => {
            if (res.code == 1) {
              this.ruleForm.cardFaceUrl = res.data.urls;
              this.ruleForm.cards.push(2);
              this.getWeiXinInfoFN(res.data.urls);
            } else {
              this.$message.error(res.msg);
            }
          });
        });
        this.ruleForm.cardFace = fileList.slice(-1);
      } else {
        this.ruleForm.cardFace = [];
        this.$message.error("请选择图片");
      }
    },
    CardFaceRemove(file, fileList) {
      this.hideUpload = fileList.length >= 1;
      this.ruleForm.cardFace.splice(0, this.ruleForm.cardFace.length);
      this.ruleForm.cardFaceUrl = "";
    },
    /* 上传营业执照 */
    handleBusiness(file, fileList) {
      let type = this.isImage(file.name);
      if (type == true) {
        this.hidezhuFile = fileList.length >= 1;
        this.getBase64(file.raw).then((res) => {
          this.uploadBase64({
            codes_base64: res.split(";base64,")[1],
            extensions: file.name.split(".")[1]
          }).then((res) => {
            if (res.code == 1) {
              this.ruleForm.businessNotesUrl = res.data.urls;
              console.log(this.ruleForm.businessNotesUrl, " this.ruleForm.businessNotesUrl ");
            } else {
              this.$message.error(res.msg);
            }
          });
        });
        this.ruleForm.businessNotes = fileList.slice(-1);
      } else {
        this.ruleForm.businessNotes = [];
        this.$message.error("请选择图片");
      }
    },
    RemoveBusiness(file, fileList) {
      this.hidezhuFile = fileList.length >= 1;
      this.ruleForm.businessNotes.splice(0, this.ruleForm.businessNotesUrl.length);
      this.ruleForm.businessNotesUrl = "";
    },
    //转化
    getBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let fileResult = "";
        reader.readAsDataURL(file);
        //开始转
        reader.onload = function () {
          fileResult = reader.result;
        };
        //转 失败
        reader.onerror = function (error) {
          reject(error);
        };
        //转 结束  咱就 resolve 出去
        reader.onloadend = function () {
          resolve(fileResult);
        };
      });
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlePictureCardPreview2(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    isImage(fileName) {
      if (typeof fileName !== "string") return;
      let name = fileName.toLowerCase();
      return name.endsWith(".png") || name.endsWith(".jpeg") || name.endsWith(".jpg") || name.endsWith(".png") || name.endsWith(".bmp");
    },
  },
};
</script>

<style>
.hide .el-upload--picture-card {
  display: none;
}
</style><style lang="scss" scoped>
::v-deep .el-date-editor .el-range-separator {
  padding: 0;
}

::v-deep .el-upload--picture-card {
  width: 330px;
}

::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 330px;
}

.time_radio ::v-deep .is-checked .el-radio__inner {
  border-color: #e72f0d;
  background: #e72f0d;
}

.main {
  //  background: #fff;
  margin-top: 20px;
  padding-bottom: 50px;
}

.from {
  width: 50%;
  margin: 0 auto;
  margin-top: 64px;
}

.main .title {
  color: #333333;
  padding: 32px;
  font-size: 18px;
  text-align: center;
  border-bottom: 1px solid #d7dbe0;

  span {
    cursor: pointer;
    color: #f12323;
  }
}

.main {
  padding-bottom: 50px;
  //background: #d7dbe0;
}

.Settle {
  width: 100%;
  //  background: #f7f8fa;
  height: 100%;
  font-size: 18px;
}

.status {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #ccc;
  padding: 20px 10px;
  font-size: 18px;
  color: #ccc;
  background: #fff;
  margin-bottom: 20px;

  p {
    padding: 4px 0px;
  }
}

.steps {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  box-sizing: border-box;
  background: #fff;
  border-top: 1px solid #eaeaea;
}

.steps p span.in {
  background: #e72f0d;
}

.steps p span {
  // background: #cccccc;
  display: block;
  border-radius: 50%;
  overflow: hidden;
  font-size: 18px;
  color: #fff;
  text-align: center;
  width: 36px;
  height: 36px;
  line-height: 36px;
  margin-right: 12px;
}

.steps .lin {
  display: block;
  width: 14%;
  background: #e6e9ed;
  height: 3px;
  margin: 0 12px;
}

.steps p {
  display: flex;
  align-items: center;
}

.steps p span i {
  font-size: 28px;
  line-height: 36px;
}

.login {
  font-size: 16px;
  color: #333333;
  width: 100%;
  text-align: center;
}

.login .link {
  color: #e72f0d;
  font-size: 16px;
  cursor: pointer;
}

.left {
  width: 13.7%;
  background: #fff;
}

.text p:first-child {
  font-size: 16px;
  color: #333333;
  width: 100%;
  text-align: center;
}

.text p:last-child {
  font-size: 12px;
  color: #999999;
  width: 100%;
  text-align: center;
  margin-top: 9px;
  margin-bottom: 43px;
}

.logo {
  margin: 24px auto;
  width: 42px;
  height: 42px;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 18px;
}

.right {
  width: 100%;
}

/* ***************** */
.face-index {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .img-index {
    display: flex;
    flex-direction: column;
    align-items: center;

    .img-text {
      color: #a4a5a7;
    }
  }
}

.opt-index {
  padding-bottom: 20px;

  h4 {
    padding: 0px 0 40px 0;
  }

  .el-date-editor--daterange.el-input__inner {
    width: 300px;
  }

  .el-cascader {
    width: 100%;
  }
}
</style>
